module.exports = __webpack_public_path__ + "static/media/BT_WS.197f96e9.svg";